<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>商城金币体力钻石配置</span>
          <clear-cache-apply />
        </div>

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="(item, index) in types" :key="index" :label="item.label" :name="item.value">
            <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
              <el-col :span="1.5">
                <el-upload
                  :ref="item.value"
                  class="upload-demo"
                  :action="sys_app_logoAction"
                  accept="xlsx"
                  :limit="1"
                  :on-success="(res)=>{return importUploadSuccess(res, item.value)}"
                  :headers="headers"
                >
                  <el-button v-permisaction="['config:shopSpinConfig:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
                </el-upload>
              </el-col>
              <el-col :span="1.5">
                <el-button
                  v-permisaction="['config:shopSpinConfig:export']"
                  type="primary"
                  icon="el-icon-download"
                  size="mini"
                  @click="exportData( item.value)"
                >导出</el-button>
              </el-col>
            </el-row>
            <el-table
              :data="tableData"
              border
              style="width: 50%"
            >
              <el-table-column
                prop="levelId"
                label="等级"
              >
                <template v-slot:default="scope">
                  <el-input v-model="scope.row.levelId" placeholder="等级" />
                </template>
              </el-table-column>
              <el-table-column
                prop="gsku"
                label="库存"
              >
                <template v-slot:default="scope">
                  <el-input v-model="scope.row.gsku" placeholder="库存" />
                </template>
              </el-table-column>
              <el-table-column
                prop="num"
                label="数量"
              >
                <template v-slot:default="scope">
                  <el-input v-model="scope.row.num" placeholder="数量" />
                </template>
              </el-table-column>
            </el-table>

            <pagination
              v-show="total>0"
              background
              :page.sync="queryParams.pageIndex"
              :limit.sync="queryParams.pageSize"
              :total="total"
              @pagination="getTables(item.value)"
            />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import {
  exportGoodsSkuCfg,
  getDiamondSpinList,
  getGoodsCoinList,
  getGoodsSpinList,
  importGoodsSkuCfg
} from '@/api/config/goods-sku-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
export default {
  name: 'ShopSpinConfig',
  components: { ClearCacheApply },
  data() {
    return {
      loading: false,
      activeName: 'money',
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      formCoinData: [],
      formSpinData: [],
      types: [{ label: '金币', value: 'money' }, { label: '体力', value: 'spins' }, { label: '钻石', value: 'diamond' }],
      tableData: []
    }
  },
  created() {
    this.getTables('money')
  },
  methods: {
    getTables(tableName) {
      switch (tableName) {
        case 'money':
          getGoodsCoinList(this.queryParams).then(res => {
            if (res.code === 200) {
              this.tableData = res.data.list
              this.total = res.data.count
            } else {
              this.msgError(res.msg)
            }
          })
          break

        case 'spins':
          getGoodsSpinList(this.queryParams).then(res => {
            if (res.code === 200) {
              this.tableData = res.data.list
              this.total = res.data.count
            } else {
              this.msgError(res.msg)
            }
          })
          break

        case 'diamond':
          getDiamondSpinList(this.queryParams).then(res => {
            if (res.code === 200) {
              this.tableData = res.data.list
              this.total = res.data.count
            } else {
              this.msgError(res.msg)
            }
          })
          break
      }
    },
    exportData(name) {
      exportGoodsSkuCfg({ name: name }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response, name) {
      this.loading = true
      importGoodsSkuCfg({ data: response.data.path, name: name }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.$refs[name][0].clearFiles()
          this.loading = false
          this.msgSuccess(res.msg)
          this.getTables(name)
        } else {
          this.loading = false
          this.msgError(res.msg)
        }
      })
    },
    handleClick(tab, event) {
      const tableName = tab.name
      this.queryParams = {
        pageIndex: 1,
        pageSize: 10
      }
      this.getTables(tableName)
    }
  }
}
</script>

<style scoped>
</style>
